// extracted by mini-css-extract-plugin
export var animationContainer = "_qr-0";
export var footer = "_qr-1";
export var gray = "_qr-2";
export var lineItem = "_qr-3";
export var lineItemImage = "_qr-4";
export var lineItemInfo = "_qr-5";
export var lineItemText = "_qr-6";
export var lineItems = "_qr-7";
export var modalContent = "_qr-8";
export var options = "_qr-9";
export var orderName = "_qr-a";
export var refundAmount = "_qr-b";